exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-simple-suggest.designed .suggestions[data-v-63f5cf3e]{top:-moz-calc(100% - 1px);top:calc(100% - 1px);max-width:100%;width:100%;-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}", ""]);

// exports
